'use client';

import { type ReactNode, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Link from '@alltrails/denali/components/Link';
import type { SeoLinkItem } from '@alltrails/types/SeoLinkItem';

type UseShowMoreLinksProps = {
  linkItems: SeoLinkItem[];
  collapsedLimit: number;
  isBot?: boolean;
  showMoreToggleClassName?: string;
};

type UseShowMoreLinksResult = {
  visibleLinkItems: SeoLinkItem[];
  showMoreSlot: ReactNode | null;
  isExpanded: boolean;
};

export default function useShowMoreLinks({
  linkItems,
  collapsedLimit,
  isBot = false,
  showMoreToggleClassName
}: UseShowMoreLinksProps): UseShowMoreLinksResult {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasMoreItems = linkItems.length > collapsedLimit;
  const showLimitedExperience = hasMoreItems && !isBot;
  const displayItems = isExpanded || !showLimitedExperience ? linkItems : linkItems.slice(0, collapsedLimit);

  const showMoreSlot = showLimitedExperience ? (
    <Link onClick={() => setIsExpanded(!isExpanded)} size="sm" variant="secondary" className={showMoreToggleClassName}>
      {isExpanded ? <FormattedMessage defaultMessage="Show less" /> : <FormattedMessage defaultMessage="Show more" />}
    </Link>
  ) : null;

  return {
    visibleLinkItems: displayItems,
    showMoreSlot,
    isExpanded
  };
}
